module.exports = __webpack_public_path__ + "img/resolutionRatio.5bb0bde1.png";